import React from "react";
import HorizontalScrollableContainer from "../Common/HorizontalScrollIContainer";
import { SpotifyAlbumInfo } from "../WeddingInfo/WeddingInfo";

interface SpotifyAlbumProps {
  albums: SpotifyAlbumInfo[];
  title: string;
}
const SpotifyAlbumList: React.FC<SpotifyAlbumProps> = ({ albums, title }) => {
  return (
    <div className="flex flex-col mx-4 mt-4 text-left mb-8">
      <div className="text-white font-bold">{title}</div>

      <HorizontalScrollableContainer>
        <div className="flex space-x-4 -ml-4 relative">
          {albums.map((album, index) => (
            <div key={index} className="w-96 h-96 relative">
              {/* 오른쪽 상단에 'Music' 추가 */}
              <div className="absolute top-2 right-2 text-white text-sm font-semibold">
                {album.topRightCaption}
              </div>

              <img
                src={album.mainImage}
                alt={`Thumbnail ${index + 1}`}
                className="w-full h-96 object-cover rounded-lg mb-1"
              />

              {/* 하단 정보 박스 */}
              <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-70 p-4 rounded-b-lg">
                <div className="text-white font-bold text-md">
                  {album.title}
                </div>
                <div className="text-gray-400 text-sm">{album.caption}</div>
              </div>
            </div>
          ))}
        </div>
      </HorizontalScrollableContainer>
    </div>
  );
};

export default SpotifyAlbumList;
